const adjustVenueHeights = () => {
	const venues = document.querySelectorAll('.js-venue');

	if (venues.length === 0) {
		return;
	}

	if (window.innerWidth > 1024) {
		let max = 0;

		venues.forEach((venue) => {
			let height = venue.getBoundingClientRect().height;

			if (height > max) {
				max = height;
			}
		});

		venues.forEach((venue) => {
			venue.style.height = max + 'px';
		});
	} else {
		venues.forEach((venue) => {
			venue.style.height = 'auto';
		});
	}
};

document.addEventListener('DOMContentLoaded', () => {
	adjustVenueHeights();
});

window.addEventListener('resize', () => {
	adjustVenueHeights();
});
